import React from 'react';
import PropTypes from 'prop-types';
import { Table, Icon, Popup } from 'semantic-ui-react';
import { connect } from 'react-redux';

class ResultItem extends React.Component {
  handleHistoric = (param, exam_code, selectedPatientID) => {
    const { graphsList, patientHistoric, goToRef } = this.props;

    if (!graphsList || graphsList.length === 0) {
      patientHistoric({
        patient_id: selectedPatientID,
        field_code: param,
        test_code: exam_code,
      });
    } else {
      const exists = graphsList.some(e => e.code === param);
      if (!exists) {
        patientHistoric({
          patient_id: selectedPatientID,
          field_code: param,
          test_code: exam_code,
        });
      }
    }
    goToRef();
  };

  render() {
    const {
      name,
      value,
      range,
      param_id,
      exam_code,
      numeric,
      selectedPatientID,
      comentario //nuevo prop
    } = this.props;

    const hasComment = comentario && comentario.trim() !== '';

    return (
      <Table.Row>
        <Table.Cell style={{fontSize:"12px"}}>{name}</Table.Cell>

        <Table.Cell textAlign="center" id="iconoGraficar">
          {!!numeric && (
            <Icon
              link
              color="blue"
              size=""
              name="chart bar"
              onClick={() =>
                this.handleHistoric(param_id, exam_code, selectedPatientID)
              }
            />
          )}
        </Table.Cell>

        <Table.Cell textAlign='center'>
          {hasComment ? (
            <Popup content={
               <div style={{
              fontSize:"0.9em",
              color:"gray",
              whiteSpace:"normal",
              overflowWrap:"break-word",
              wordBreak:"break-word",
              overflow:"hidden",
              textAlign:"left",
              maxWidth:"100%",
              //maxHeight:"150px",
              boxSizing: "border-box",
              overflowY:"auto",
            }}
              dangerouslySetInnerHTML={{ __html: comentario.replace(/<pre>|<\/pre>/g, "")}}>
            </div>
            } trigger={
              <span
                style={{
                  cursor:"help",
                  borderBotton:"1px dotted gray",
                }}
              >
                {value}
                  <Icon
                    name="info circle"
                    size="small"
                    color="grey"
                    style={{ marginLeft: "5px" }}
                  />
              </span>
            } 
            position="top center"
            hoverable
            wide="very">
         
            </Popup>
            
          ) : (
            <div>{value}</div>
          )
        }
          
          </Table.Cell>
        <Table.Cell textAlign='center'>{range}</Table.Cell>
      </Table.Row>
    );
  }
}

ResultItem.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  range: PropTypes.string,
  patientHistoric: PropTypes.func.isRequired,
  comentario: PropTypes.string, // 👈 nuevo
};

const mapStateToProps = state => ({
  graphsList: state.graphsList,
});

export default connect(mapStateToProps)(ResultItem);
